import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-page-not-found-view',
  templateUrl: './page-not-found-view.component.html',
  styleUrls: ['./page-not-found-view.component.scss'],
  standalone: false
})
export class PageNotFoundViewComponent {
  constructor(private router: Router) {}

  navigateToHomepage() {
    this.router.navigateByUrl('');
  }
}
